<template>
    <div class="container">

        <top></top>

        <list></list>

        <div class="major">
            <div class="content">
                <div class="carousel">
                    <el-carousel :interval="5000">
                        <el-carousel-item v-for="item in items" :key="item.img" class="item-img">
                            <img :src="item.img" alt="">
                        </el-carousel-item>
                    </el-carousel>
                </div>
            </div>

            <div class="main">
                <div class="company">
                    <h2><span v-t="'company'"></span></h2>
                    <div class="company-main">
                        <div class="company-main-left">
                            <img src="../assets/images/com.jpg" alt="">
                        </div>
                        <div class="company-main-right">
                            <h3 v-t="'company_title'"></h3>
                            <div class="company-word">
                                <p class="p1" v-t="'p1'"></p>
                                <p class="p2" v-t="'p2'"></p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="characteristic">
                    <h2 v-t="'characteristic'"></h2>
                    <div class="characteristic-main">
                        <ul>
                            <li><img src="../assets/images/USB-Wi-Fi.jpg" alt=""></li>
                            <li><img src="../assets/images/Industry4G.jpg" alt=""></li>
                            <li><img src="../assets/images/outdoors4G.jpg" alt=""></li>
                            <li><img src="../assets/images/Portable.jpg" alt=""></li>
                        </ul>
                    </div>
                </div>

               <!-- <div class="video">
                   <video preload loop muted playsinline autoplay="autoplay">
                       <source src="https://video.usr.cn/4d49f21b3177434288c07d5973162b8d/a25c4f532eb4496884dc019fea67fa6a-S00000001-200000.mp4" type="video/webm">
                       <source src="https://video.usr.cn/4d49f21b3177434288c07d5973162b8d/a25c4f532eb4496884dc019fea67fa6a-S00000001-200000.mp4" type="video/mp4">
                   </video>
               </div> -->

                <div class="hot">
                    <h2><span v-t="'Hot_selling_series'"></span></h2>
                    <div class="hot-main">
                        <ol>
                            <li @click="open('A');" v-bind:class="{'active':(active=='A') }"><a href="javascript:void(0)">LC111</a></li>
                            <li @click="open('B');" v-bind:class="{'active':(active=='B') }"><a href="javascript:void(0)">T115</a></li>
                            <li @click="open('C');" v-bind:class="{'active':(active=='C') }"><a href="javascript:void(0)">LDW931</a></li>
                            <li @click="open('D');" v-bind:class="{'active':(active=='D') }"><a href="javascript:void(0)">GC111</a></li>
                            <li @click="open('E');" v-bind:class="{'active':(active=='E') }"><a href="javascript:void(0)">M55</a></li>
                            <li @click="open('F');" v-bind:class="{'active':(active=='F') }"><a href="javascript:void(0)">D21</a></li>
                        </ol>
                        <ul>
                            <li class="block" v-show="block=='A'">
                                <img src="../assets/images/CPE-LC116.jpg" alt="" @click="lc111">
                                <div>
                                    <h3>LC111</h3>
                                    <p v-t="'LC111'"></p>
                                </div>
                            </li>
                            <li class="block" v-show="block=='B'">
                                <img src="../assets/images/MiFi-T115.jpg" alt="" @click="t115">
                                <div>
                                    <h3>T115</h3>
                                    <p v-t="'T115'"></p>
                                </div>
                            </li>
                            <li class="block" v-show="block=='C'">
                                <img src="../assets/images/UFi-P012.jpg" alt="" @click="ldw931">
                                <div>
                                    <h3>LDW931</h3>
                                    <p v-t="'LDW931'"></p>
                                </div>
                            </li>
                            <li class="block" v-show="block=='D'">
                                <img src="../assets/images/Industry-GC111.jpg" alt="" @click="gc111">
                                <div>
                                    <h3>GC111</h3>
                                    <p v-t="'GC111'"></p>
                                </div>
                            </li>
                            <li class="block" v-show="block=='E'">
                                <img src="../assets/images/Industry-N55.jpg" alt="" @click="m55">
                                <div>
                                    <h3>M55</h3>
                                    <p v-t="'M55'"></p>
                                </div>
                            </li>
                            <li class="block" v-show="block=='F'">
                                <img src="../assets/images/D21.jpg" alt="">
                                <div>
                                    <h3>D21</h3>
                                    <p v-t="'D21'"></p>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

        <bottom></bottom>

    </div>
</template>

<script>
    import top from "../components/common/Head";
    import list from "../components/common/Nav";
    import bottom from "../components/common/Foot";

    export default {
        components: {
            top,
            list,
            bottom,
        },
        data() {
            return {
                items: [
                    {img: require('../assets/img-Gc111/GC111.jpg')},
                    {img: require('../assets/images/T300.jpg')},
                    {img: require('../assets/img-N55/N55.jpg')},
                    {img: require('../assets/images/4Goutdoors.jpg')},
                ],
                active: 'A',
                block: 'A',
            }
        },
        methods:{
            open(show) {
                this.active = show;
                this.block = show;
            },

            lc111(){
                this.$router.push("/cpeLC111")
            },
            t115(){
                this.$router.push("/t115")
            },
            ldw931(){
                this.$router.push("/ldw931")
            },
            gc111(){
                this.$router.push("/gc111")
            },
            m55(){
                this.$router.push("/m55")
            },
        }
    }
</script>

<style scoped>
    .carousel{
        display: flex;
        justify-content: center;
    }
    /deep/.el-carousel__container{
        width: 1300px;
        height: 550px;
    }
    /deep/.el-carousel__arrow{
        width: 70px;
        height: 70px;
        font-size: 46px;
        color: white;
    }
    .item-img img{
        /*width: 100%;*/
        /*height: 100%;*/
        width: 1300px;
        height: 550px;
    }
    .company{
        width: 100%;
        margin-top: 40px;
        display: flex;
        flex-direction: column;
    }
    .company h2{
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .company h2 span{
        border-bottom: 2px solid #c7000b;
        padding-bottom: 10px;
    }
    .company-main{
        width: 100%;
        display: flex;
        /*background-image: url("../assets/images/bg.jpg");*/
        /*background-repeat: no-repeat;*/
        /*background-size: 100% 100%;*/
        background-color: whitesmoke;
        margin-top: 30px;
    }
    .company-main-left{
        width: 300px;
        height: 185px;
        background-color: gold;
    }
    .company-main-left img{
        width: 300px;
        height: 185px;
    }
    .company-main-right{
        display: flex;
        flex-direction: column;
        margin-left: 15px;
    }
    .company-main-right h3{
        width: 685px;
        text-align: left;
        margin: 2px 0  10px;
    }
    .company-word{
        width: 685px;
        height: 148px;
        display: flex;
        flex-direction: column;
    }
    .company-word p{
        line-height: 17px;
        font-size: 14px;
        color: #696969;
        text-indent: 2em;
        margin: 0;
        text-align: left;
        padding-right: 5px;
        word-break: break-all;
        word-wrap: break-word;
    }
    .company-word .p1{
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        overflow: hidden;
    }
    .company-word .p2{
        margin-top: 5px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 5;
        overflow: hidden;
    }
    .characteristic{
        width: 100%;
        margin-top: 40px;
        display: flex;
        flex-direction: column;
    }
    .characteristic h2{
        width: 100%;
        text-align: left;
    }
    .characteristic-main{
        width: 100%;
    }
    .characteristic-main ul{
        display: flex;
        justify-content: space-between;
        padding-left: 0;
    }
    .characteristic-main ul li{
        width: 220px;
        height: 140px;
        cursor: pointer;
        transition: transform .4s ease;
    }
    .characteristic-main ul li:hover{
        transform: scale(1.2);
    }
    .characteristic-main ul li img{
        width: 220px;
        height: 140px;
        display: block;
    }
    .video{
        width: 100%;
        margin-top: 40px;
    }
    .video video{
        width: 100%;
        height: 100%;
        transition: .35s;
        min-width: 100%;
        min-height: 100%;
        object-fit: cover;
        display: inline-block;
        vertical-align: baseline;
    }
    .hot{
        width: 100%;
        margin-top: 40px;
        display: flex;
        flex-direction: column;
    }
    .hot h2{
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .hot h2 span{
        border-bottom: 2px solid #c7000b;
        padding-bottom: 10px;
    }
    .hot-main{
        width: 100%;
        margin-top: 40px;
        display: flex;
        background-image: url("../assets/images/bg2.jpg");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        justify-content: space-between;
    }
    .hot-main ol{
        width: 20%;
        height: 100%;
        padding: 0;
        margin: 0;
    }
    .hot-main ol li{
        padding: 8px 0;
        margin: 10px 0;
        background-color: #F0F8FF;
        cursor: pointer;
    }
    .hot-main ol .active{
        background-color: #FFFACD;
    }
    .hot-main ol li a{
        color: black;
    }
    .hot-main ul{
        width: 80%;
        padding: 0;
        margin: 20px;
        overflow: hidden;
    }
    .hot-main ul li{
        width: 100%;
        height: 100%;
        display: flex;
    }
    .hot-main ul li img{
        width: 310px;
        height: 235px;
        cursor: pointer;
    }
    .hot-main ul li div{
        margin-left: 15px;
    }
    .hot-main ul li h3{
        text-align: left;
    }
    .hot-main ul li p{
        text-indent: 2em;
        text-align: left;
        word-break: break-all;
        word-wrap: break-word;
    }
</style>